import { Injectable } from '@angular/core';
import { AboutUsComponent } from 'src/app/about-us/about-us.component';
import { BPBillRequestFormComponent } from 'src/app/bill-payments/bp-billRequest-form/bp-billRequest-form.component';
import { ContactUsComponent } from 'src/app/contact-us/contact-us.component';
import { FaqComponent } from 'src/app/faq/faq.component';
import { OtpPageComponent } from 'src/app/pre-login/otp-page/otp-page.component';
import { PreLoginResultPageComponent } from 'src/app/pre-login/pre-login-result-page/pre-login-result-page.component';
import { OpenNewCurrentAccountComponent } from 'src/app/retail/accounts/open-new-current-account/open-new-current-account.component';
import { OpenNewSavingsAccountComponent } from 'src/app/retail/accounts/open-new-savings-account/open-new-savings-account.component';
import { RequestChequeBookComponent } from 'src/app/retail/accounts/request-cheque-book/request-cheque-book.component';
import { RequestDdComponent } from 'src/app/retail/accounts/request-dd/request-dd.component';
import { TransactionInfoComponent } from 'src/app/retail/accounts/transaction-info/transaction-info.component';
import { TransactionSearchComponent } from 'src/app/retail/accounts/transaction-search/transaction-search.component';
import { OpenNewDepositComponent } from 'src/app/retail/deposits/open-new-deposit/open-new-deposit.component';
import { RepaymentScheduleComponent } from 'src/app/retail/loans/repayment-schedule/repayment-schedule.component';
import { PurchaseOrderComponent } from 'src/app/retail/mutual-funds/purchase-order/purchase-order.component';
import { SellOrderComponent } from 'src/app/retail/mutual-funds/sell-order/sell-order.component';
import { ServiceRequestTrackerComponent } from 'src/app/retail/service-request/service-request-tracker/service-request-tracker.component';
import { BeneficiaryListComponent } from 'src/app/retail/transfers/beneficiary-list/beneficiary-list.component';
import { PaymentsFilterComponent } from 'src/app/retail/transfers/payments-filter/payments-filter.component';
import { TransferBeneficiaryComponent } from 'src/app/retail/transfers/transfer-beneficiary/transfer-beneficiary.component';
import { SecurityTipsComponent } from 'src/app/security-tips/security-tips.component';
import { ResultComponent } from '../../components/result/result.component';
import { PopupItem } from './popup-item';
import { TransactionDetailsFormComponent } from 'src/app/casa-accounts/transaction-details-form/transaction-details-form.component';
import { BillPaymentHistoryDetailComponent } from 'src/app/bill-payments/bill-payment-history-detail/bill-payment-history-detail.component';
import { ResultPageComponent } from 'src/app/process-shell/result-page/result-page.component';
import { DepositDetailComponent } from 'src/app/deposits/deposit-detail-form/deposit-detail-form.component';
import { CASATransactionFilterFormComponent } from 'src/app/casa-accounts/casa-transaction-filter-form/casa-transaction-filter-form.component';
import { CreditCardFilterComponent } from 'src/app/credit-card/credit-card-filter/credit-card-filter.component';

import { TransfersFilterFormComponent } from 'src/app/transfers/transfers-filter-form/transfers-filter-form.component';
import { PfmCategoryDetailsFormComponent } from 'src/app/pfm/pfm-category-details-form/pfm-category-details-form.component';
import { ProfilePicChooserComponent } from '../../components/profile-pic-chooser/profile-pic-chooser.component';
import { PfmFundsDetailFormComponent } from 'src/app/pfm/pfm-funds-detail-form/pfm-funds-detail-form.component';
import { EMICalculationDisplayGridComponent } from 'src/app/tools/emi-calculation-display-grid/emi-calculation-display-grid.component';
import { TransferHistoryDetailComponent } from 'src/app/transfers/transfer-history-detail/transfer-history-detail.component';
import { MailboxFilterComponent } from 'src/app/mailbox/mailbox-filter/mailbox-filter.component';
import { ScheduleHistoryDetailComponent } from 'src/app/transfers/schedule-history-detail/schedule-history-detail.component';
import { ManageBeneFormComponent } from 'src/app/transfers/manage-bene-form/manage-bene-form.component';
import { UnpostedTransactiondtlsDisplayGridComponent } from 'src/app/foundation/unposted-transactiondtls-display-grid/unposted-transactiondtls-display-grid.component';
import {TapnpayTncFormComponent} from 'src/app/tap-n-pay/tapnpay-tnc-form/tapnpay-tnc-form.component';
import { TapnpayconfirmationComponent } from 'src/app/tap-n-pay/tapnpayconfirmation/tapnpayconfirmation.component';
import { LoanTransactionFilterFormComponent } from 'src/app/Loans/loan-transaction-filter-form/loan-transaction-filter-form.component';
import { LoanDetailsFormComponent } from 'src/app/casa-accounts/loan-details-form/loan-details-form.component';
import { PopUpDetailComponent } from 'src/app/mobile-topup/popup-component/popup-detail.component';


@Injectable({
  providedIn: 'root',
})
export class PopupService {
  getPopup(path) {

    let children: PopupItem;
    switch (path) {
      case 'repaymentSchedule':
        children = new PopupItem(RepaymentScheduleComponent, {});
        break;
      case 'transactionInfo':
        children = new PopupItem(TransactionInfoComponent, {});
        break;
      case 'beneficiaryList':
        children = new PopupItem(BeneficiaryListComponent, {});
        break;
      case 'transactionSearch':
        children = new PopupItem(TransactionSearchComponent, {});
        break;
      case 'paymentFilter':
        children = new PopupItem(PaymentsFilterComponent, {});
        break;
      case 'preLoginResultPage':
        children = new PopupItem(PreLoginResultPageComponent, {});
        break;
      case 'aboutUs':
        children = new PopupItem(AboutUsComponent, {});
        break;
      case 'faq':
        children = new PopupItem(FaqComponent, {});
        break;
      case 'contactus':
        children = new PopupItem(ContactUsComponent, {});
        break;
      case 'securityTips':
        children = new PopupItem(SecurityTipsComponent, {});
        break;
      case 'result':
        children = new PopupItem(ResultComponent, {});
        break;
      case 'otp':
        children = new PopupItem(OtpPageComponent, {});
        break;
      case 'tracker':
        children = new PopupItem(ServiceRequestTrackerComponent, {});
        break;
      case 'CHQBKREQ':
        children = new PopupItem(RequestChequeBookComponent, {});
        break;
      case 'DDREQ':
        children = new PopupItem(RequestDdComponent, {});
        break;
      case 'PAYMENTACH':
      case 'PAYMENTSWIFT':
        children = new PopupItem(TransferBeneficiaryComponent, {});
        break;
      case 'MFPURCHASEORDER':
        children = new PopupItem(PurchaseOrderComponent, {});
        break;
      case 'MFSELLORDER':
        children = new PopupItem(SellOrderComponent, {});
        break;
      case 'billPaymentHistoryFilter':
        children = new PopupItem(BPBillRequestFormComponent, {});
        break;
        case 'loanDetailsForm':
          children = new PopupItem(LoanDetailsFormComponent, {});
           break;
      case 'transactionDetails':
          children = new PopupItem(TransactionDetailsFormComponent, {});
           break;
      case 'billPaymentHistoryDetailComponent':
            children = new PopupItem(BillPaymentHistoryDetailComponent, {});
        	  break;
      case 'pfmCategoryDetailsFormComponent':
            children = new PopupItem(PfmCategoryDetailsFormComponent, {});
            break;
      case 'result-info':
            children = new PopupItem(ResultPageComponent, {});
            break;
      case 'deposit-detail-form':
            children = new PopupItem(DepositDetailComponent, {});
            break;
	    case 'transactionFilter':
            children = new PopupItem(CASATransactionFilterFormComponent, {});
            break;
      case 'loantransactionFilter':
              children = new PopupItem(LoanTransactionFilterFormComponent, {});
              break;
      case 'creditCardFilter':
            children = new PopupItem(CreditCardFilterComponent, {});
            break;
      case 'transfersFilterForm':
            children = new PopupItem(TransfersFilterFormComponent, {});
            break;
      case 'TapnpayTncFormComponent':
            children = new PopupItem(TapnpayTncFormComponent, {});
            break;
      case 'TapnpayconfirmationComponent':
            children = new PopupItem(TapnpayconfirmationComponent, {});
            break;
      case 'profilepicChooser':
            children = new PopupItem(ProfilePicChooserComponent, {});
            break;
      case 'pfmFundsDetailsFormComponent':
            children = new PopupItem(PfmFundsDetailFormComponent, {});
            break;
      case 'EMICalculationDisplayGridComponent':
            children = new PopupItem(EMICalculationDisplayGridComponent   , {});
            break;
      case 'MailboxFilterComponent':
            children = new PopupItem(MailboxFilterComponent   , {});
            break;
      case 'TransferHistoryDetailComponent':
            children = new PopupItem(TransferHistoryDetailComponent   , {});
            break;
      case 'ScheduleHistoryDetailComponent':
            children = new PopupItem(ScheduleHistoryDetailComponent   , {});
            break;
      case 'ManageBeneFormComponent':
            children = new PopupItem(ManageBeneFormComponent   , {});
            break;
      case 'UnpostedTransactiondtlsDisplayGridComponent':
            children = new PopupItem(UnpostedTransactiondtlsDisplayGridComponent, {});
            break;
      case 'PopUpDetailComponent':
            children = new PopupItem(PopUpDetailComponent   , {});
            break;
            
      // case 'OPENNEWCA':
      //   children = new PopupItem(OpenNewCurrentAccountComponent, {});
      //     break;
      // case 'OPENNEWSA':
      //   children = new PopupItem(OpenNewSavingsAccountComponent, {});
      //     break;
      // case 'OPENNEWDA':
      //   children = new PopupItem(OpenNewDepositComponent, {});
      //     break;
    }

    return children;
  }
}
